import { render, staticRenderFns } from "./WorkClientPersonTable.vue?vue&type=template&id=d30fd462&"
import script from "./WorkClientPersonTable.vue?vue&type=script&lang=js&"
export * from "./WorkClientPersonTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports